import { render, staticRenderFns } from "./GalleryType3.vue?vue&type=template&id=419210af"
import script from "./GalleryType3.vue?vue&type=script&lang=js"
export * from "./GalleryType3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('419210af')) {
      api.createRecord('419210af', component.options)
    } else {
      api.reload('419210af', component.options)
    }
    module.hot.accept("./GalleryType3.vue?vue&type=template&id=419210af", function () {
      api.rerender('419210af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/gallery/GalleryType3.vue"
export default component.exports